<template>
  <div class="sidebar dinline-block vtop bg-red tcenter">
    <div class="st fs24 twhite">栏目导航</div>
    <div class="alist br8">
      <div class="adiv bgw">
        <template v-for="(item,index) in $params.practiceColumn">
          <router-link v-if="item.type==1" :to="{path:item.to,query:{id:item.params.id,pid:item.params.pid}}" class="sa fs18 dblock" :class="{active:item.params.id==$route.query.id}">{{item.name}}</router-link>
          <a v-else-if="item.type==3" :href="item.to" class="sa fs18 dblock" target="_blank">{{item.name}}</a>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PracticeLeft",
}
</script>

<style scoped>
  .sidebar{width: 270px;}
  .sidebar .st{height: 100px;line-height: 100px;}
  .sidebar .adiv{min-height: 415px;background: #f0f0f0;}
  .sidebar .adiv a{padding-left: 80px;height: 55px;line-height: 55px;}
  .sidebar .adiv a:last-child{border-bottom: none;}
  .sidebar .adiv a:hover{background-color: #fefefe;}
  .sidebar .adiv a.active{font-weight: bold;background: url(../../assets/images/cn1.png) no-repeat 27px -1213px;}

  .bar-menu2 .st{height: 68px;line-height: 68px;}
  .bar-menu2 .alist{margin: 0 10px 15px;padding: 10px 8px 8px;background: #fff;}
  .bar-menu2 .ast{margin-bottom: 5px;height: 50px;line-height: 50px;background: #f4f3f3;}
  .bar-menu2 .adiv{min-height: auto;background: #fff;}
  .bar-menu2 .adiv a,.bar-menu2 .adiv .sa{margin-bottom: 5px;padding: 0;height: 45px;line-height: 45px;background: #f4f3f3;}
  .bar-menu2 .adiv .sa.active,.bar-menu2 .adiv .sa:hover:not(.active){background: #94070a;color: #fff;}
  .bar-menu2 .hsa div{display: none;}
  .bar-menu2 .sdiv a:hover{color: #94070a;}
  .bar-menu2 .sactive{background: none;color: #94070a;}
  .bar-menu2 .sactive span{display: inline-block;}
  .bar-menu2 .hsa:active div{display: block;}
  .bar-menu2 .menu{width: 930px;}
</style>


// WEBPACK FOOTER //
// src/components/practice/Left.vue